import { HStack, IconButton } from '@chakra-ui/react';
import { BsThreeDotsVertical } from 'react-icons/bs';

import CopyCellRenderer from 'components/tables/AGGrid/CustomCells/CopyCellRenderer';
import Tooltip from 'components/v4/Tooltip';
import ActionsCellWrapper from 'components/tables/AGGrid/ActionsCellWrapper';

/**
 * Builds the AG Grid column definitions for the Regions table.
 *
 * @param {object}   params
 * @param {boolean}  params.darkMode      Current dark mode state.
 * @param {function} params.onEditRegion  Called with the row data when the edit action is clicked.
 * @returns {Array} AG Grid column definitions.
 */
export const getRegionsTableColumns = ({ darkMode, onEditRegion }) => [
    {
        headerName: 'Name',
        field: 'name',
        cellRenderer: CopyCellRenderer,
        cellStyle: () => ({ width: '100%' }),
        flex: 1,
        minWidth: 150,
    },
    {
        headerName: 'Locations',
        field: 'locations',
        flex: 1,
        minWidth: 150,
    },
    {
        headerName: 'Voice Policies',
        field: 'voicePoliciesDisplay',
        flex: 1,
        minWidth: 150,
    },
    {
        headerName: 'Action',
        maxWidth: 100,
        filter: false,
        suppressMovable: true,
        lockVisible: true,
        suppressColumnsToolPanel: true,
        suppressHeaderMenuButton: true,
        suppressHeaderFilterButton: true,
        enableRowGroup: false,
        resizable: false,
        sortable: false,
        cellStyle: () => ({
            display: 'flex',
            alignItems: 'center',
        }),
        lockPosition: 'right',
        cellRenderer: (params) => (
            <ActionsCellWrapper>
                <HStack
                    spacing={0}
                    justifyContent="center"
                    alignItems="center"
                    width="100%"
                    height="100%">
                    <Tooltip label="Edit Region">
                        <IconButton
                            icon={
                                <BsThreeDotsVertical
                                    fill={darkMode ? 'white' : 'black'}
                                />
                            }
                            aria-label="Edit"
                            variant="ghost"
                            onClick={() => {
                                onEditRegion(params.data);
                            }}
                            _hover={{
                                bg: darkMode
                                    ? 'whiteAlpha.200'
                                    : 'blackAlpha.100',
                            }}
                            _active={{
                                bg: darkMode
                                    ? 'whiteAlpha.300'
                                    : 'blackAlpha.200',
                            }}
                            _focus={{ boxShadow: 'none' }}
                        />
                    </Tooltip>
                </HStack>
            </ActionsCellWrapper>
        ),
    },
];
